<div class="dialog-container">
    <div class="dialog-content">
      <div class="dialog-header">
        <h2>Update {{user.name}} Status</h2>
        <button class="close-button" (click)="closeDialog()">×</button>
      </div>
  
      <form [formGroup]="updateUserForm" class="exam-form">
        <div class="form-field">
          <label for="userStatus">User Status:</label>
          <input type="text" id="userStatus" formControlName="userStatus" class="form-input" />
        </div>
        <button
          (click)="updateUserStatus()"
          [disabled]="!updateUserForm.valid"
          class="generate-button"
        >
          Update User Status
        </button>
      </form>
    </div>
  </div>